<template>
	<div class="pb-30">
		<h1 class="match-header">Send {{email.name}}</h1>
		<md-card>
			<!--<md-card-header>
				<div class="md-title card-header">Preview {{template}} email for: <b>{{ ask.subject }}</b></div>
			</md-card-header>-->
			<md-card-content>
				<md-card>
					<md-card-header>
						Subject: {{email.subject}}
					</md-card-header>
					<md-card-content>
						<md-tabs>
							<md-tab id="tab-html" md-label="HTML">
								<div id='previewHTML'>HTML preview...</div>
							</md-tab>
							<md-tab id="tab-text" md-label="Text">
								<div id='previewText' class='text-preview'>Text preview...</div>
							</md-tab>
							<md-tab id="tab-attachments" md-label="Attachments">
								<div id='previewAttachments'><i>(none)</i></div>
							</md-tab>
						</md-tabs>
					</md-card-content>
				</md-card><br />
				<!--<md-card>
					<md-card-header>
						Email Recipient(s)
					</md-card-header>
					<md-card-content>
						<multi-member-picker v-if="advisors.length >0" :changed="updateSelected" :members="advisors" :selected="selectedAdvisors">Advisors goes here...</multi-member-picker>
					</md-card-content>
				</md-card><br />-->
				<md-card>
					<md-card-header>
						Matched Advisors
					</md-card-header>
					<md-card-content class="scrollable">
							<matched-advisors :advisors="advisors" @changed="updateSelected" :ask="ask">Advisors goes here...</matched-advisors>
					</md-card-content>
				</md-card><br />
				<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import MultiMemberPicker from "./MultiMemberPicker";
import MatchedAdvisors from "./MatchedAdvisors";
import ActivityLog from "./ActivityLog";
import Comments from "./Comments";
import AskFeedback from "./AskFeedback";

export default {
  name: "SendEmail",
  props: ["template", "action"],
  components: {
    MultiMemberPicker,
    MatchedAdvisors,
    ActivityLog,
    Comments,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      ask: {},
      email: { subject: "", html: "", text: "" },
      advisors: [],
      selectedAdvisors: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData: async function() {
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
        this.ask = ask.data;
        if (this.ask) {
          this.ask.recommendedAdvisors.map(async id => {
            await this.api.get(`members/${id}`).then(member => {
              this.advisors.push(member.data);
            });
          });
          await this.api
            .get(
              `asks/${this.$route.params.ask_id}/preview_email/${this.template}`
            )
            .then(preview => {
              this.email = preview.data;
              window.previewHTML.innerHTML = this.email.html;
              window.previewText.innerText = this.email.text;
          });
        }
      });
    },
    updateSelected: function(selectedList) {
      this.selectedAdvisors = selectedList;
    },
    doInteraction: async function() {
      if (this.action === 'send-request') {
      	this.api.post(`asks/${this.ask._id}/send-mail`, {
  			ask: this.ask,
			recipients: [this.ask.createdByMemberID._id],
	      	template: 'share', //'Share',
	      	type: 'request'
	    });
      }
	  await this.api
	    .post(`asks/${this.ask._id}/${this.action}`, {
	      recipients: this.selectedAdvisors
	    })
	    .then(response => {
	      this.$emit("reload");
	      this.$router.push('/');
	  });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractSendEmail.vue